<template>
  <div class="steps">
    <el-steps :active="stepCount" simple>
      <el-step icon="el-icon-edit">
        <template slot="title">
          <span class="text-xs">Basic Details</span>
        </template>
      </el-step>
      <el-step icon="el-icon-folder-opened">
        <template slot="title">
          <span class="text-xs">Catalog Grouping</span>
        </template>
      </el-step>
      <el-step icon="el-icon-document-copy">
        <template slot="title">
          <span class="text-xs">Attach Attributes</span>
        </template>
      </el-step>
      <el-step icon="el-icon-setting">
        <template slot="title">
          <span class="text-xs">Configurations</span>
        </template>
      </el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  name: 'Steps',
  props: {
    stepCount: {
      type: Number,
      default: 0,
      required: true,
    },
  },
};
</script>

<style scoped>

</style>
